export default __webpack_public_path__ + "static/media/32.6df0f639.jpeg";